var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_512_6658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 17.7001C13.8049 17.7001 17.7 13.8049 17.7 9.00005C17.7 4.19517 13.8049 0.300049 8.99999 0.300049C4.19511 0.300049 0.299988 4.19517 0.299988 9.00005C0.299988 13.8049 4.19511 17.7001 8.99999 17.7001Z",
    fill: "#196A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27863 12.621L5.23863 10.6284C5.1945 10.5855 5.15943 10.5342 5.13547 10.4775C5.11152 10.4209 5.09918 10.36 5.09918 10.2984C5.09918 10.2369 5.11152 10.176 5.13547 10.1193C5.15943 10.0626 5.1945 10.0113 5.23863 9.96842L5.91513 9.30842C6.00585 9.22052 6.12721 9.17137 6.25353 9.17137C6.37985 9.17137 6.50121 9.22052 6.59193 9.30842L7.80633 10.4955L11.2122 5.31752C11.2825 5.21303 11.3907 5.13997 11.5138 5.11377C11.637 5.08757 11.7655 5.11029 11.8722 5.17712L12.6774 5.68292C12.73 5.71526 12.7756 5.75783 12.8114 5.80811C12.8472 5.85839 12.8726 5.91535 12.886 5.97561C12.8994 6.03588 12.9006 6.09822 12.8894 6.15895C12.8783 6.21967 12.8551 6.27754 12.8211 6.32912L8.78823 12.4623C8.70741 12.5824 8.60127 12.6832 8.47726 12.7578C8.35325 12.8324 8.21439 12.8789 8.07047 12.8941C7.92655 12.9092 7.78106 12.8926 7.64425 12.8454C7.50744 12.7982 7.38264 12.7216 7.27863 12.621Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_512_6658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.62a2aae62e0e1933f882dc7722194cb3.svg";
export { ForwardRef as ReactComponent };